enum ListState {
  Loading,
  Error,
  Data,
  NoData,
}

export function useListState() {
  const state = ref<ListState>(ListState.Loading);

  return {
    ListState,

    state,
  };
}
